import styled from 'styled-components';

export const StyledBottomRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 3.2rem;
  width: 100%;
  padding: 0 4rem 4rem 4rem;

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    flex-direction: column-reverse;
    align-items: stretch;
  }
`;

export const StyledButtonRow = styled.div`
  display: flex;
  gap: 1.6rem;

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
		flex-direction: column-reverse;
		width: 100%;

		& > * {
			width: 100%;
		}
	}
`;

export const StyledProgressBar = styled.div<{ amountOfSteps: number; currentStep: number }>`
  width: 37.5rem;
  height: 0.5rem;
  background: ${({ theme }) => theme.colors.grey[400]};
  opacity: 0.9;
  position: relative;
  border-radius: 0.25rem;

  &::after {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: ${({ amountOfSteps, currentStep }) =>
      `${Math.min(100, Math.max(0, (currentStep / Math.max(1, amountOfSteps)) * 100))}%`};
    height: 100%;
    background: ${({ theme }) => theme.colors.success.secondary};
    border-radius: 0.25rem;
    transition: width 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  }

 @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    width: 100%;
  }
`;
